module.exports = __webpack_public_path__ + "img/logo-7112.a0feb2a9.png";